import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './lang/messages'
import store from '../store/store'

Vue.use(VueI18n)

store.state.countryCode = document.getElementById('tracking').getAttribute('langue').toUpperCase();
let lang = document.getElementById('tracking').getAttribute('langue')
if(window.location.pathname.search('nl-be') > -1){
  lang = 'nlbe';
}

const i18n = new VueI18n({
  // locale: navigator.language.split('-')[0] || process.env.VUE_APP_I18N_LOCALE,
  locale: lang,
  fallbackLocale: 'fr',
  messages,
})

export default i18n